import { render, staticRenderFns } from "./customized.vue?vue&type=template&id=adffebb6&scoped=true"
import script from "./customized.vue?vue&type=script&lang=js"
export * from "./customized.vue?vue&type=script&lang=js"
import style0 from "./customized.vue?vue&type=style&index=0&id=adffebb6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adffebb6",
  null
  
)

export default component.exports